import { render, staticRenderFns } from "./bottomButton.vue?vue&type=template&id=5dda8f3c&scoped=true"
import script from "./bottomButton.vue?vue&type=script&lang=js"
export * from "./bottomButton.vue?vue&type=script&lang=js"
import style0 from "./bottomButton.vue?vue&type=style&index=0&id=5dda8f3c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dda8f3c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5dda8f3c')) {
      api.createRecord('5dda8f3c', component.options)
    } else {
      api.reload('5dda8f3c', component.options)
    }
    module.hot.accept("./bottomButton.vue?vue&type=template&id=5dda8f3c&scoped=true", function () {
      api.rerender('5dda8f3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/template/frontPageManage/configureManage/mobilePreview/components/bottomButton.vue"
export default component.exports